module.exports = __webpack_public_path__ + "static/img/5.03f1464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/5.jpg
// module id = wr5C
// module chunks = 1